/**
 * 用户行为跟踪
 */
class UserTrack {
    /**
     * 跟踪页面跳转
     * @param {*} to 目标地址
     * @param {*} from 来源页URL地址
     */
    view(to, from) {
        if (window._czc) {
            // eslint-disable-next-line
            _czc.push(["_trackPageview", to.fullPath, from.fullPath]);
        }
    }
    /**
     * 跟踪事件
     * @param {*} category [必填] 表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等。
     * @param {*} action [必填] 表示访客跟元素交互的行为动作，如"播放"、"收藏"、"翻层"等等。	
     * @param {*} label [选填] 用于更详细的描述事件，如具体是哪个视频，哪部小说。	
     * @param {*} value [选填] 用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格。	
     * @param {*} nodeid [选填] 填写事件元素的div元素id。	
     */
    event(category, action, label, value, nodeid) {
        if (window._czc) {
            // eslint-disable-next-line
            _czc.push(["_trackEvent",category,action,label,value,nodeid]);
        }
    }
}
export default new UserTrack();